import { Stack, Typography } from "@mui/material";
import profileTargetImg from "../assets/profileTarget.png";
import solutionSlidersImg from "../assets/solutionSliders.png";
import summaryPlanImg from "../assets/summaryPlan.png";

const LandingInfo = () => (
  <Stack spacing={8} maxWidth={800}>
    <Stack spacing={2}>
      <Typography variant={"h3"} textAlign={"center"} color={"primary.dark"}>
        Find your footing
      </Typography>
      <Typography variant={"body1"} textAlign={"center"}>
        Decarbonization targets are getting harder to ignore, but where do you
        actually start? Explore proven decarbonization strategies, understand
        their costs and impact, and narrow down the approaches worth
        investigating further.
      </Typography>
    </Stack>

    <Stack spacing={2}>
      <Typography variant={"h4"} textAlign={"center"} color={"primary.dark"}>
        Choose an emissions profile and set a target
      </Typography>
      <Typography variant={"body1"} textAlign={"center"}>
        Jump right in using our ready-made emission profiles and preset targets
        or customize your own numbers to get more tailored results.
      </Typography>
      <img
        src={profileTargetImg}
        width={"100%"}
        alt="Screenshot of target setting workflow in emissions reduction planner"
      />
    </Stack>

    <Stack spacing={2}>
      <Typography variant={"h5"} textAlign={"center"} color={"primary.dark"}>
        Explore solutions to achieve your target
      </Typography>
      <Typography variant={"body1"} textAlign={"center"}>
        Compare different solutions to understand the real trade-offs between
        cost, feasibility, and availability.
      </Typography>
      <img
        src={solutionSlidersImg}
        width={"100%"}
        alt="Screenshot of moving solution sliders to achieve your target"
      />
    </Stack>

    <Stack spacing={2}>
      <Typography variant={"h5"} textAlign={"center"} color={"primary.dark"}>
        Get your plan
      </Typography>
      <Typography variant={"body1"} textAlign={"center"}>
        See your personalized recommendations and visual summaries that make it
        easier to prioritize your next move and discuss options with
        stakeholders.
      </Typography>
      <img
        src={summaryPlanImg}
        width={"100%"}
        alt="Screenshot of emissions reduction plan summary and recommendations"
      />
    </Stack>
  </Stack>
);

export default LandingInfo;
